// extracted by mini-css-extract-plugin
export default {"resetPasswordConfirmationContainer":"-PbKK","resetPasswordConfirmationHeader":"IukXn","resetPasswordConfirmationContent":"DQF8H"};